<script setup lang="ts">
import { getApiEnvironmentLabel, getApiEnvironmentTone } from '@utils/devEnvironment'

const { appEnv, backendUrl } = defineProps<{ appEnv: string; backendUrl: string }>()
const show = defineModel<boolean>('show', { default: false })
const visible = computed(() => import.meta.dev || appEnv !== 'production')
const tone = computed(() => getApiEnvironmentTone(backendUrl))
const label = computed(() => getApiEnvironmentLabel(backendUrl))
</script>

<template lang="pug">
  Teleport(to="body")
    .development-environment(v-if="visible || tone" :class="{ 'development-environment--green': tone === 'green', 'development-environment--coral': tone === 'coral', 'development-environment--gray': tone === 'gray' }")
      .highlight.position-fixed.t-0.l-0.r-0.h-80.z-index-100(v-if="tone" aria-hidden="true")
      .badge-position.position-fixed.l-0.t-50p.z-index-450(v-if="visible")
        DevOnly
          button.badge.border-none.cursor-pointer(type="button" :aria-label="`${label}: настройки разработки`" :aria-expanded="show" @click="show = !show") {{ label }}
          template(#fallback)
            span.badge {{ label }}

</template>

<style scoped>
.development-environment--green {
  --development-color: var(--cue-contrast-contrast-5-default);
  --development-badge-bg: var(--cue-contrast-contrast-5-soft);
  --development-badge-content: var(--cue-contrast-contrast-5-on-soft);
}

.development-environment--coral {
  --development-color: var(--cue-contrast-contrast-6-default);
  --development-badge-bg: var(--cue-contrast-contrast-6-soft);
  --development-badge-content: var(--cue-contrast-contrast-6-on-soft);
}

.development-environment--gray {
  --development-color: var(--cue-contrast-contrast-7-default);
  --development-badge-bg: var(--cue-contrast-contrast-7-soft);
  --development-badge-content: var(--cue-contrast-contrast-7-on-soft);
}

.highlight {
  pointer-events: none;
  mix-blend-mode: multiply;
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--development-color) 75%, transparent),
    transparent,
    transparent,
    transparent
  );
}

.badge-position {
  transform: translateY(-50%);
}

.badge {
  --uno: flex-center-center w-24 p-12-0 br-0 br-r-12 typ-12-16-500;
  writing-mode: vertical-rl;
  background: var(--development-badge-bg, var(--cue-bg-neutral-tertiary));
  color: var(--development-badge-content, var(--cue-content-neutral-primary));
}
</style>
